/**
 * Mapeia uma notificação para a rota relevante no app.
 * Cliente é roteado para o portal; demais perfis para a área interna.
 *
 * Tipos conhecidos (do backend):
 * - tarefa_atribuida / tarefa_status / tarefa_adiamento / tarefa_conclusao /
 *   tarefa_reabertura / tarefa_mencao / tarefa_prazo_proximo /
 *   tarefa_aprovador / tarefa_aprovacao_pendente / tarefa_aprovada / tarefa_rejeitada
 * - projeto_comentario / projeto_comentario_cliente
 * - assinatura_pendente / assinatura_finalizada
 * - pagamento_vencimento
 * - prazo_projeto
 * - apontamento_pendente
 */
export function caminhoDaNotificacao(
  n: { tipo: string; referenciaId?: string | null },
  perfil: string | undefined,
): string {
  const ref = n.referenciaId || "";
  const ehCliente = perfil === "cliente";

  if (n.tipo.startsWith("tarefa_")) {
    if (ehCliente) return "/cliente";
    return ref ? `/tarefas?tarefa=${ref}` : "/tarefas";
  }

  if (n.tipo.startsWith("foco_")) {
    // Lembrete de marcar "Estou nessa". Leva pro kanban de tarefas;
    // se a notif referencia a tarefa que fechou, abre o drawer direto.
    if (ehCliente) return "/cliente";
    return ref ? `/tarefas?tarefa=${ref}` : "/tarefas";
  }

  if (n.tipo.startsWith("tempo_ajuste_")) {
    // Ajuste de tempo pendente/decidido — referenciaId é a tarefa; abre o drawer
    // onde ficam as correções (e os botões de aprovar/rejeitar do gestor).
    if (ehCliente) return "/cliente";
    return ref ? `/tarefas?tarefa=${ref}` : "/tarefas";
  }

  if (n.tipo.startsWith("projeto_comentario")) {
    return ehCliente
      ? (ref ? `/cliente/projetos/${ref}` : "/cliente")
      : (ref ? `/projetos/${ref}` : "/projetos");
  }

  if (n.tipo.startsWith("assinatura_")) {
    // referenciaId é o ID do documento de assinatura, não do projeto.
    // Sem o projetoId não temos como linkar direto; vamos pra lista do projeto
    // (cliente) ou de projetos (interno) — a seção de assinaturas fica visível.
    if (ehCliente) return "/cliente";
    return "/projetos";
  }

  if (n.tipo === "pagamento_vencimento" || n.tipo.startsWith("contrato_")) {
    if (ehCliente) return "/cliente";
    return "/financeiro";
  }

  if (n.tipo === "prazo_projeto") {
    if (ehCliente) return ref ? `/cliente/projetos/${ref}` : "/cliente";
    return ref ? `/projetos/${ref}` : "/projetos";
  }

  if (n.tipo === "apontamento_pendente") {
    return ehCliente ? "/cliente" : "/apontamentos";
  }

  // Fallback
  return ehCliente ? "/cliente" : "/";
}
